<div>
	<div class="row align-items-center">
		<div class="col-md-4">
			<div class="fill-width">
				<mat-form-field class="w-100 pe-2">
					<mat-label>Wybierz termin od</mat-label>
					<input
						matInput
						name="parseFilters.term__gte"
						[ngModel]="parseFilters().term__gte"
						(ngModelChange)="updateParseFilter('term__gte', $event)"
						[matDatepicker]="term__gte"
					/>
					<mat-hint></mat-hint>
					<mat-datepicker-toggle matSuffix [for]="term__gte"></mat-datepicker-toggle>
					<mat-datepicker #term__gte> </mat-datepicker>
				</mat-form-field>
				<mat-form-field class="w-100 ps-2">
					<mat-label>Wybierz termin do</mat-label>
					<input
						matInput
						name="parseFilters.term__lte"
						[ngModel]="parseFilters().term__lte"
						(ngModelChange)="updateParseFilter('term__lte', $event)"
						[matDatepicker]="term__lte"
					/>
					<mat-hint></mat-hint>
					<mat-datepicker-toggle matSuffix [for]="term__lte"></mat-datepicker-toggle>
					<mat-datepicker #term__lte> </mat-datepicker>
				</mat-form-field>
			</div>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="filters.reservation_seller"
				[(ngModel)]="filters.reservation_seller"
				[multiple]="true"
				placeholder="Agent"
			>
				<ng-option *ngFor="let item of agencies()" [value]="item.id">{{ item.shortName }}</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<mat-form-field class="w-100">
				<mat-label>Numer rezerwacji</mat-label>
				<input matInput [(ngModel)]="filters.table_id__in" placeholder="Numer rezerwacji" />
			</mat-form-field>
		</div>
	</div>
	<div class="row align-items-center">
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="filters.status__in"
				[(ngModel)]="filters.status__in"
				[multiple]="true"
				placeholder="Status"
			>
				<ng-option *ngFor="let item of statusOptions()" [value]="item.id">{{ item.name }}</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<ng-select
				class="custom"
				appendTo="body"
				name="filters.kind"
				[ngModel]="filters.kind"
				(ngModelChange)="onKindChange($event)"
				[multiple]="false"
				placeholder="Rodzaj"
			>
				<ng-option *ngFor="let item of kindOptions" [value]="item.id">{{ item.name }}</ng-option>
			</ng-select>
		</div>
		<div class="col-md-4">
			<div class="text-end mt-3">
				<button class="me-2 mat-button-save-filters" mat-raised-button color="primary" (click)="filtersSave()">
					Pokaż
				</button>
				<button mat-raised-button class="mat-button-clear-all" (click)="filtersClear()">Wyczyść</button>
			</div>
		</div>
	</div>
</div>
